import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./navbar/Navbar";

const LayoutNoFoot = () => {
  return (
    <>
      <Navbar />
      <Outlet />
    </>
  );
};

export default LayoutNoFoot;
